/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ConfirmedbasketsIdNopaymentmethodPut200Response model module.
 * @module model/ConfirmedbasketsIdNopaymentmethodPut200Response
 * @version 1.0.0
 */
class ConfirmedbasketsIdNopaymentmethodPut200Response {
    /**
     * Constructs a new <code>ConfirmedbasketsIdNopaymentmethodPut200Response</code>.
     * @alias module:model/ConfirmedbasketsIdNopaymentmethodPut200Response
     */
    constructor() { 
        
        ConfirmedbasketsIdNopaymentmethodPut200Response.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ConfirmedbasketsIdNopaymentmethodPut200Response</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ConfirmedbasketsIdNopaymentmethodPut200Response} obj Optional instance to populate.
     * @return {module:model/ConfirmedbasketsIdNopaymentmethodPut200Response} The populated <code>ConfirmedbasketsIdNopaymentmethodPut200Response</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ConfirmedbasketsIdNopaymentmethodPut200Response();

            if (data.hasOwnProperty('orderId')) {
                obj['orderId'] = ApiClient.convertToType(data['orderId'], 'Number');
            }
            if (data.hasOwnProperty('basketRefId')) {
                obj['basketRefId'] = ApiClient.convertToType(data['basketRefId'], 'String');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
            if (data.hasOwnProperty('currency')) {
                obj['currency'] = ApiClient.convertToType(data['currency'], 'String');
            }
            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ConfirmedbasketsIdNopaymentmethodPut200Response</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ConfirmedbasketsIdNopaymentmethodPut200Response</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['basketRefId'] && !(typeof data['basketRefId'] === 'string' || data['basketRefId'] instanceof String)) {
            throw new Error("Expected the field `basketRefId` to be a primitive type in the JSON string but got " + data['basketRefId']);
        }
        // ensure the json data is a string
        if (data['currency'] && !(typeof data['currency'] === 'string' || data['currency'] instanceof String)) {
            throw new Error("Expected the field `currency` to be a primitive type in the JSON string but got " + data['currency']);
        }
        // ensure the json data is a string
        if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
            throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
        }
        // ensure the json data is a string
        if (data['status'] && !(typeof data['status'] === 'string' || data['status'] instanceof String)) {
            throw new Error("Expected the field `status` to be a primitive type in the JSON string but got " + data['status']);
        }

        return true;
    }


}



/**
 * @member {Number} orderId
 */
ConfirmedbasketsIdNopaymentmethodPut200Response.prototype['orderId'] = undefined;

/**
 * @member {String} basketRefId
 */
ConfirmedbasketsIdNopaymentmethodPut200Response.prototype['basketRefId'] = undefined;

/**
 * @member {Number} userId
 */
ConfirmedbasketsIdNopaymentmethodPut200Response.prototype['userId'] = undefined;

/**
 * @member {String} currency
 */
ConfirmedbasketsIdNopaymentmethodPut200Response.prototype['currency'] = undefined;

/**
 * @member {String} message
 */
ConfirmedbasketsIdNopaymentmethodPut200Response.prototype['message'] = undefined;

/**
 * @member {String} status
 */
ConfirmedbasketsIdNopaymentmethodPut200Response.prototype['status'] = undefined;






export default ConfirmedbasketsIdNopaymentmethodPut200Response;

